export enum WidgetManagerSelectorTypes {
  SelectedWidgetDefinition = '[Widget Manager] Selected Widget Definition',
  CurrentLayout = '[Widget Manager] Selected Current Layout',
  CurrentLayoutIdentity = '[Widget Manager] Selected Current Layout Identity',
  LayoutToLoad = '[Widget Manager] Selected Layout To Load',
  LayoutKeys = '[Widget Manager] Layout Keys',
  ResetLayout = '[Widget Manager] Reset Layout',
}
